import { useMemo } from 'react';
import { DocItem } from 'src/@types/docs';
import { ExplorerMenuItem } from '../shared/ExplorerMenuItem';
import { DocsExplorerLabel } from './DocsExplorerLabel';

type Props = {
  doc: DocItem;
  selectDoc: (doc: DocItem) => void;
  isSelected: (doc: DocItem) => boolean;
  docs?: DocItem[];
};

export const DocsExplorerItem = ({
  doc,
  selectDoc,
  isSelected,
  docs,
}: Props) => {
  const docChildren = useMemo(() => {
    if (!docs?.length) return [];
    if (doc._id === 'root') {
      return docs.filter((item) => !item.parent && !item.noteRef);
    }
    return docs.filter((item) => item.parent === doc._id);
  }, [docs, doc._id]);

  const selected = isSelected(doc);

  return (
    <>
      <ExplorerMenuItem
        hasChildren={!!docChildren.length}
        selected={selected}
        onClick={() => selectDoc(doc)}
        labelChild={<DocsExplorerLabel doc={doc} />}
        childrenChild={docChildren?.map((item) => (
          <DocsExplorerItem
            key={item._id}
            doc={item}
            selectDoc={selectDoc}
            isSelected={isSelected}
            docs={docs}
          />
        ))}
      />
    </>
  );
};
